import { IconButton, Snackbar } from '@mui/joy';
import { FC, ReactNode } from 'react';
import { FaXmark } from 'react-icons/fa6';
import { create } from 'zustand';

const DEFAULT_DURATION = 2000;

interface SnackbarOptions {
  /** 표시 시간(ms). 미지정 시 기본 2초 유지. */
  duration?: number;
  /** 닫기(X) 버튼 노출 여부. 미지정 시 노출 안 함(기존 동작 유지). */
  closable?: boolean;
}

interface MinddSnackbarState {
  message: string;
  duration: number;
  closable: boolean;
  add: (message: string, options?: SnackbarOptions) => void;
  clear: () => void;
}

const useMinddSnackbarStore = create<MinddSnackbarState>((set) => ({
  message: '',
  duration: DEFAULT_DURATION,
  closable: false,
  add: (message, options) =>
    set({
      message,
      duration: options?.duration ?? DEFAULT_DURATION,
      closable: options?.closable ?? false,
    }),
  clear: () => set({ message: '' }),
}));

export const useMinddSnackbar = () => {
  const message = useMinddSnackbarStore((state) => state.message);
  const add = useMinddSnackbarStore((state) => state.add);
  const clear = useMinddSnackbarStore((state) => state.clear);

  return { message, add, clear };
};

const MinddSnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const message = useMinddSnackbarStore((state) => state.message);
  const duration = useMinddSnackbarStore((state) => state.duration);
  const closable = useMinddSnackbarStore((state) => state.closable);
  const clear = useMinddSnackbarStore((state) => state.clear);

  return (
    <>
      {children}
      {message && (
        <Snackbar
          autoHideDuration={duration}
          open={true}
          variant={'solid'}
          sx={{ background: '#000000CC' }}
          endDecorator={
            closable ? (
              <IconButton
                size="sm"
                variant="plain"
                onClick={() => clear()}
                sx={{ color: '#FFF', minHeight: 0, minWidth: 0 }}
                aria-label="닫기">
                <FaXmark />
              </IconButton>
            ) : undefined
          }
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            clear();
          }}>
          {message}
        </Snackbar>
      )}
    </>
  );
};

export default MinddSnackbarProvider;
